<template>
  <div
    v-if="experienceRequirements[0]"
    class="candidate applications experience-eligibility-icon"
    @click="$emit('click')"
  >
    <div class="pr-3" style="cursor: pointer;">
      <v-badge slot="activator" :value="true" :color="color" class="requirement__badge" bottom left>
        <v-icon slot="badge" dark small>{{ icon }}</v-icon>
        <v-avatar :color="color" size="44">
          <v-avatar color="white" size="38">
            <v-icon> mdi-briefcase </v-icon>
          </v-avatar>
        </v-avatar>
      </v-badge>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    opportunity: { type: Object, required: true },
    progress: { type: Number, default: 0 },
  },
  computed: {
    color() {
      if (this.done) return this.satisfied ? 'success' : 'error'
      return this.satisfied ? 'success' : 'muted'
    },

    done() {
      return this.progress >= 100
    },

    eligibility() {
      return this.$store.getters['candidate/eligibilities/forOpportunity'](this.opportunity.id)
    },

    experienceRequirements() {
      if (!this.requirementGroups) return []

      return this.requirementGroups.filter(group => group.type === 'ExperienceRequirementGroup')
    },

    icon() {
      if (this.done) return this.satisfied ? 'mdi-thumb-up' : 'mdi-thumb-down'
      return this.satisfied ? 'mdi-thumb-up' : 'mdi-help'
    },

    isEligible() {
      return this.eligibility && this.eligibility.eligible
    },

    requirementGroups() {
      return _.get(this, 'eligibility.requirementGroups')
    },

    satisfied() {
      return this.isEligible || !this.experienceRequirements.some(r => !r.satisfied)
    },
  },
}
</script>

<style lang="scss">
.candidate.applications.experience-eligibility-icon {
  .requirement__badge span {
    bottom: -2px;
    left: -11px;
  }
}
</style>
